import { create } from 'zustand';
import { getHealthAuthorities } from '../api/providerApi';

const useHealthAuthorityStore = create((set) => ({
    healthAuthorities: [],
    loading: false,
    error: null,

    fetchHealthAuthorities: async () => {
        set({ loading: true, error: null });

        try {
            const data = await getHealthAuthorities();
            set({ healthAuthorities: data, loading: false });
        } catch (err) {
            set({
                error: err.message || 'Failed to load health authorities',
                loading: false,
            });
        }
    },
}));

export default useHealthAuthorityStore;
